export default __webpack_public_path__ + "static/media/flag-1.6abdc0ec.gif";